import { createContext, type FC, type ReactNode } from 'react';
import { getFeaturesFlags } from './getFeatureFlags';

export const FlagContext = createContext<Record<string, boolean>>(
    getFeaturesFlags()
);

export const FlagProvider: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <FlagContext.Provider value={getFeaturesFlags()}>
            {children}
        </FlagContext.Provider>
    );
};
